"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScript = void 0;
const react_1 = require("react");
const useScript_types_1 = require("./useScript.types");
const SCRIPT_CACHE = new Map();
const loadScript = (src) => {
    const cached = SCRIPT_CACHE.get(src);
    if (cached)
        return cached;
    const promise = new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        const onLoad = () => {
            cleanUp();
            resolve();
        };
        const onError = () => {
            cleanUp();
            SCRIPT_CACHE.delete(src);
            script.remove();
            reject(new Error("Could not mount new script element"));
        };
        const cleanUp = () => {
            script.removeEventListener("load", onLoad);
            script.removeEventListener("error", onError);
        };
        script.addEventListener("load", onLoad);
        script.addEventListener("error", onError);
        document.body.appendChild(script);
    });
    SCRIPT_CACHE.set(src, promise);
    return promise;
};
const useScript = (src) => {
    const [status, setStatus] = (0, react_1.useState)(useScript_types_1.ScriptStatus.Pending);
    (0, react_1.useEffect)(() => {
        let aborted = false;
        const onLoad = () => {
            if (aborted)
                return;
            setStatus(useScript_types_1.ScriptStatus.Loaded);
        };
        const onError = () => {
            if (aborted)
                return;
            setStatus(useScript_types_1.ScriptStatus.Failed);
        };
        loadScript(src).then(onLoad).catch(onError);
        return () => {
            aborted = true;
        };
    }, [src]);
    return status;
};
exports.useScript = useScript;
//# sourceMappingURL=useScript.js.map